import { render, staticRenderFns } from "./order-submit-pills-table.vue?vue&type=template&id=45835762&scoped=true"
import script from "./order-submit-pills-table.vue?vue&type=script&lang=js"
export * from "./order-submit-pills-table.vue?vue&type=script&lang=js"
import style0 from "./order-submit-pills-table.vue?vue&type=style&index=0&id=45835762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45835762",
  null
  
)

export default component.exports